import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { goBackToHistory } from '../utils/history-navigation-utils';

@Component({
  selector: 'sanction-historyresult',
  templateUrl: './sanction-historyresult.component.html',
  styleUrls: ['./sanction-historyresult.component.scss']
})
export class SanctionHistoryResultComponent implements OnInit {

  isSavingRecord;
  individualData = JSON.parse(localStorage.getItem('historyData'))

  constructor(private location: Location) { }

  ngOnInit(): void {
  }

  goBack() {
    goBackToHistory(this.location);
  }

}
